import axios from 'axios';

/**
 * Reverts all matches' "User Modified" sections to "System Detected" state and syncs to backend.
 * 
 * @param {function} setData React state setter for the data object
 * @param {string} comparisonID The current comparison ID (needed for URLs)
 */
export const revertAllMatches = async (setData, comparisonID) => {
  let updatedData = null;

  setData((prevData) => {
    if (
      !prevData ||
      !prevData.results ||
      !prevData.cleanParsedEstData ||
      !prevData.cleanParsedInsData
    ) {
      console.error("❌ Missing expected data structure");
      return prevData;
    }

    const newData = structuredClone(prevData);

    const updateZoneForIds = (lineItemsArray, ids, label) => {
      ids.forEach((targetId) => {
        let found = false;
        for (const obj of lineItemsArray) {
          const key = Object.keys(obj)[0];
          const item = obj[key];
          if (key === targetId && item) {
            item.userModifiedZone = item.detectedZone;
            item.locked = false; // locked true if key starts with 'li1', else false
            found = true;
            break;
          }
        }
        if (!found) {
          console.warn(`⚠️ Could not find ${targetId} in ${label}`);
        }
      });
    };
    

    for (const result of newData.results) {
      const matchObj = result.Matches?.[0];
      if (!matchObj) continue;

      const matchKey = Object.keys(matchObj)[0];
      const matchBlock = matchObj[matchKey];

      const userModified = matchBlock["User Modified"];
      const systemDetected = matchBlock["System Detected"];

      if (!userModified || !systemDetected) {
        console.warn(`⚠️ Missing User Modified or System Detected for matchId: ${result.id}`);
        continue;
      }

      const doc1Ids = userModified.doc1?.ids || [];
      const doc2Ids = userModified.doc2?.ids || [];

      updateZoneForIds(newData.cleanParsedEstData.lineItems, doc1Ids, "EstData", true);  // doc1 locked = true
      updateZoneForIds(newData.cleanParsedInsData.lineItems, doc2Ids, "InsData", false);  // doc2 locked = false

      matchBlock["User Modified"] = JSON.parse(JSON.stringify(systemDetected));
    }

    updatedData = newData;
    return newData;
  });

  // Wait one tick to ensure state has been applied
  await new Promise((resolve) => setTimeout(resolve, 0));

  if (!updatedData) {
    console.error("❌ No updated data available for DB sync");
    return;
  }

  try {
    const zone1URL = `${process.env.REACT_APP_ZONE1_UPDATE}/${comparisonID}`;
    const zone2URL = `${process.env.REACT_APP_ZONE2_UPDATE}/${comparisonID}`;
    const resultsURL = `${process.env.REACT_APP_UPDATE_RESULTS}/${updatedData?.resultsID}`;

    const [zone1Res, zone2Res, resultsRes] = await Promise.all([
      axios.put(zone1URL, { cleanParsedEstData: updatedData.cleanParsedEstData }),
      axios.put(zone2URL, { cleanParsedInsData: updatedData.cleanParsedInsData }),
      axios.put(resultsURL, { data: updatedData }),
    ]);

  } catch (error) {
    console.error("❌ Error updating DB:", error);
  }
};
